/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThread.defs'
export { main as default } from './getPostThread.defs'
